(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function showError(root) {
    var loading = root.querySelector('[data-panch-loading]');
    if (loading) {
      loading.textContent = 'Panchangam is temporarily unavailable. Please check back later.';
      loading.hidden = false;
    }
    var body = root.querySelector('[data-panch-body]');
    if (body) body.hidden = true;
  }

  // Middletown, CT (11 Training Hill Road, Middletown, CT 06457)
  var OBSERVER = new Astronomy.Observer(41.5623, -72.6506, 30);
  var TIME_ZONE = 'America/New_York';

  var TITHI_NAMES = [
    'Prathama', 'Dwitiya', 'Tritiya', 'Chaturthi', 'Panchami', 'Shashthi', 'Saptami',
    'Ashtami', 'Navami', 'Dashami', 'Ekadasi', 'Dwadasi', 'Trayodasi', 'Chaturdasi'
  ];

  var NAKSHATRA_NAMES = [
    'Ashwini', 'Bharani', 'Krittika', 'Rohini', 'Mrigashira', 'Ardra', 'Punarvasu',
    'Pushya', 'Ashlesha', 'Magha', 'Purva Phalguni', 'Uttara Phalguni', 'Hasta',
    'Chitra', 'Swati', 'Vishakha', 'Anuradha', 'Jyeshtha', 'Mula', 'Purva Ashadha',
    'Uttara Ashadha', 'Shravana', 'Dhanishta', 'Shatabhisha', 'Purva Bhadrapada',
    'Uttara Bhadrapada', 'Revati'
  ];

  // Segment number (1-8, counting from sunrise), indexed by JS weekday 0=Sun..6=Sat
  var RAHU_SEGMENT = [8, 2, 7, 5, 6, 4, 3];
  var YAMA_SEGMENT = [5, 4, 3, 2, 1, 7, 6];
  var GULIKA_SEGMENT = [7, 6, 5, 4, 3, 2, 1];

  function fmtTime(date) {
    return new Intl.DateTimeFormat('en-US', {
      hour: 'numeric', minute: '2-digit', hour12: true, timeZone: TIME_ZONE
    }).format(date);
  }

  function fmtDate(date) {
    return new Intl.DateTimeFormat('en-US', {
      weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', timeZone: TIME_ZONE
    }).format(date);
  }

  function easternDateString(date) {
    return new Intl.DateTimeFormat('en-CA', {
      timeZone: TIME_ZONE, year: 'numeric', month: '2-digit', day: '2-digit'
    }).format(date);
  }

  function localWeekday(date) {
    var wd = new Intl.DateTimeFormat('en-US', { weekday: 'short', timeZone: TIME_ZONE }).format(date);
    var map = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
    return map[wd];
  }

  function findEventForToday(body, direction, todayStr) {
    var t = new Date(Date.now() - 24 * 3600000);
    for (var i = 0; i < 5; i++) {
      var found = Astronomy.SearchRiseSet(body, OBSERVER, direction, t, 1.5);
      if (!found) return null;
      var d = found.date;
      if (easternDateString(d) === todayStr) return d;
      t = new Date(d.getTime() + 60000);
    }
    return null;
  }

  function ayanamsaLahiri(date) {
    var jd = date.getTime() / 86400000 + 2440587.5;
    var yearsSinceJ2000 = (jd - 2451545.0) / 365.25;
    return 23.85333 + 0.013972 * yearsSinceJ2000;
  }

  function moonSiderealLongitude(date) {
    var eclip = Astronomy.EclipticGeoMoon(date);
    var lon = eclip.lon - ayanamsaLahiri(date);
    return ((lon % 360) + 360) % 360;
  }

  // Finds when the Moon's sidereal longitude next reaches targetLon, via hourly
  // sampling + linear interpolation (Moon moves ~0.55 deg/hour, so this is accurate
  // to well within a minute for display purposes).
  function searchNakshatraBoundary(startDate, targetLon) {
    var stepMs = 3600000;
    var prev = startDate;
    var prevVal = moonSiderealLongitude(prev);
    var limit = startDate.getTime() + 2 * 86400000;

    for (var t = startDate.getTime() + stepMs; t <= limit; t += stepMs) {
      var cur = new Date(t);
      var curVal = moonSiderealLongitude(cur);
      var diffToTarget = ((targetLon - prevVal) + 360) % 360;
      var stepAdvance = ((curVal - prevVal) + 360) % 360;
      if (stepAdvance >= diffToTarget) {
        var fraction = stepAdvance > 0 ? diffToTarget / stepAdvance : 0;
        return new Date(prev.getTime() + fraction * (cur.getTime() - prev.getTime()));
      }
      prev = cur;
      prevVal = curVal;
    }
    return null;
  }

  function setText(root, attr, value) {
    var el = root.querySelector('[data-panch-' + attr + ']');
    if (!el) return;
    if (value == null || value === '') {
      var row = el.closest('[data-panch-row]');
      if (row) row.hidden = true;
      return;
    }
    el.textContent = value;
  }

  function renderPanchangam(root) {
    var now = new Date();
    var todayStr = easternDateString(now);

    var sunrise = findEventForToday(Astronomy.Body.Sun, 1, todayStr);
    var sunset = findEventForToday(Astronomy.Body.Sun, -1, todayStr);
    var moonrise = findEventForToday(Astronomy.Body.Moon, 1, todayStr);
    var moonset = findEventForToday(Astronomy.Body.Moon, -1, todayStr);

    if (!sunrise || !sunset) {
      showError(root);
      return;
    }

    // Tithi and Nakshatra are evaluated at sunrise, matching classical panchangam convention.
    var moonPhaseAtSunrise = Astronomy.MoonPhase(sunrise);
    var tithiIndex = Math.floor(moonPhaseAtSunrise / 12);
    var tithiInPaksha = (tithiIndex % 15) + 1;
    var isShukla = tithiIndex < 15;
    var paksha = isShukla ? 'Shukla Paksha' : 'Krishna Paksha';
    var tithiName = tithiInPaksha === 15
      ? (isShukla ? 'Purnima' : 'Amavasya')
      : TITHI_NAMES[tithiInPaksha - 1];
    var tithiBoundary = ((tithiIndex + 1) * 12) % 360;
    var tithiEnd = Astronomy.SearchMoonPhase(tithiBoundary, sunrise, 2);

    var moonSidLon = moonSiderealLongitude(sunrise);
    var nakshatraIndex = Math.floor(moonSidLon / (360 / 27));
    var nakshatraName = NAKSHATRA_NAMES[nakshatraIndex];
    var nakshatraBoundary = ((nakshatraIndex + 1) * (360 / 27)) % 360;
    var nakshatraEnd = searchNakshatraBoundary(sunrise, nakshatraBoundary);

    var dayLenMs = sunset.getTime() - sunrise.getTime();
    var segMs = dayLenMs / 8;
    var weekday = localWeekday(sunrise);

    function segRange(seg1based) {
      var start = new Date(sunrise.getTime() + (seg1based - 1) * segMs);
      var end = new Date(start.getTime() + segMs);
      return fmtTime(start) + ' - ' + fmtTime(end);
    }

    var specialAuto = '';
    if (tithiName === 'Ekadasi') specialAuto = 'Ekadasi';
    else if (tithiName === 'Purnima') specialAuto = 'Purnima';
    else if (tithiName === 'Amavasya') specialAuto = 'Amavasya';

    setText(root, 'date', fmtDate(now));
    setText(root, 'sunrise', fmtTime(sunrise));
    setText(root, 'sunset', fmtTime(sunset));
    setText(root, 'moonrise', moonrise ? fmtTime(moonrise) : null);
    setText(root, 'moonset', moonset ? fmtTime(moonset) : null);
    setText(root, 'paksha', paksha);
    setText(root, 'tithi', tithiName + (tithiEnd ? ' till ' + fmtTime(tithiEnd.date) : ''));
    setText(root, 'nakshatra', nakshatraName + (nakshatraEnd ? ' till ' + fmtTime(nakshatraEnd) : ''));
    setText(root, 'rahu', segRange(RAHU_SEGMENT[weekday]));
    setText(root, 'yama', segRange(YAMA_SEGMENT[weekday]));
    setText(root, 'gulika', segRange(GULIKA_SEGMENT[weekday]));

    var specialEl = root.querySelector('[data-panch-special]');
    if (specialEl && specialEl.textContent.trim() === '' && specialAuto) {
      specialEl.textContent = specialAuto;
      specialEl.hidden = false;
    }

    var loading = root.querySelector('[data-panch-loading]');
    if (loading) loading.hidden = true;
    var body = root.querySelector('[data-panch-body]');
    if (body) body.hidden = false;
  }

  ready(function () {
    var root = document.querySelector('[data-panchangam]');
    if (!root) return;

    if (typeof Astronomy === 'undefined') {
      showError(root);
      return;
    }

    try {
      renderPanchangam(root);
    } catch (err) {
      console.error('Panchangam calculation failed:', err);
      showError(root);
    }
  });
})();
